import React, { useState, useEffect, useRef, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useMutation } from "react-query";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

import AppContext from "../appContext";
import * as api from "../services";
import { logging } from "../tools";

export default function RouterPrompt(props) {
  const { when } = props;
  const { t } = useTranslation();
  const {
    app: {
      client: { id: clientId, unlocked },
      sessionId,
    },
  } = useContext(AppContext);

  const unlockMutation = useMutation(
    () => api.requestUnlock({ clientId, sessionId }),
    {
      onSuccess: () => logging(`UNLOCK CLIENT ${clientId}`),
    }
  );

  const history = useHistory();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentLocation, setCurrentLocation] = useState(null);

  const unblockRef = useRef();

  function handleShowModal() {
    setShowPrompt(true);
  }

  function onCancel() {
    setShowPrompt(false);
  }

  useEffect(() => {
    unblockRef.current = history.block((location) => {
      if (when) {
        setCurrentLocation(location);
        handleShowModal();
        return false;
      }
      return true;
    });
    return () => {
      unblockRef.current && unblockRef.current();
    };
  }, [when]);

  function handleConfirm() {
    if (unblockRef) {
      unblockRef.current();
    }
    setShowPrompt(false);
    history.push(currentLocation);
    if (unlocked === 0) unlockMutation.mutate();
  }

  return (
    <Dialog
      open={showPrompt}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t("common.notifications.leavePage")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t("common.notifications.unsavedChanges")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          {t("common.actions.stayOnPage")}
        </Button>
        <Button onClick={handleConfirm} autoFocus>
          {t("common.actions.leave")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
